/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Deletereview1Inputs */

const id_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus ulasan`)
};

const ms_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padam ulasan`)
};

const da_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet anmeldelse`)
};

const de_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung löschen`)
};

const en_us2_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete review`)
};

const es_es2_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar reseña`)
};

const es_mx2_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar reseña`)
};

const fil_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggalin ang review`)
};

const fr_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'avis`)
};

const it_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina recensione`)
};

const hu_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értékelés törlése`)
};

const nl_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review verwijderen`)
};

const no_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slett omtale`)
};

const pl_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń recenzję`)
};

const pt_br2_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete review`)
};

const pt_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar avaliação`)
};

const ro_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Șterge recenzia`)
};

const fi_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista arvostelu`)
};

const sv_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta bort recension`)
};

const vi_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa đánh giá`)
};

const tr_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorumu sil`)
};

const cs_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat recenzi`)
};

const bg_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтриване на ревю`)
};

const ru_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить обзор`)
};

const uk_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалити відгук`)
};

const ar_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف المراجعة`)
};

const hi_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा हटाएँ`)
};

const th_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบรีวิว`)
};

const ja_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビューを削除`)
};

const zh_cn2_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete review`)
};

const zh_hant1_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete review`)
};

const ko_forms_review_deletereview1 = /** @type {(inputs: Forms_Review_Deletereview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete review`)
};

/**
* | output |
* | --- |
* | "Delete review" |
*
* @param {Forms_Review_Deletereview1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_deletereview1 = /** @type {((inputs?: Forms_Review_Deletereview1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Deletereview1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_deletereview1(inputs)
	if (locale === "ms") return ms_forms_review_deletereview1(inputs)
	if (locale === "da") return da_forms_review_deletereview1(inputs)
	if (locale === "de") return de_forms_review_deletereview1(inputs)
	if (locale === "en-US") return en_us2_forms_review_deletereview1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_deletereview1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_deletereview1(inputs)
	if (locale === "fil") return fil_forms_review_deletereview1(inputs)
	if (locale === "fr") return fr_forms_review_deletereview1(inputs)
	if (locale === "it") return it_forms_review_deletereview1(inputs)
	if (locale === "hu") return hu_forms_review_deletereview1(inputs)
	if (locale === "nl") return nl_forms_review_deletereview1(inputs)
	if (locale === "no") return no_forms_review_deletereview1(inputs)
	if (locale === "pl") return pl_forms_review_deletereview1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_deletereview1(inputs)
	if (locale === "pt") return pt_forms_review_deletereview1(inputs)
	if (locale === "ro") return ro_forms_review_deletereview1(inputs)
	if (locale === "fi") return fi_forms_review_deletereview1(inputs)
	if (locale === "sv") return sv_forms_review_deletereview1(inputs)
	if (locale === "vi") return vi_forms_review_deletereview1(inputs)
	if (locale === "tr") return tr_forms_review_deletereview1(inputs)
	if (locale === "cs") return cs_forms_review_deletereview1(inputs)
	if (locale === "bg") return bg_forms_review_deletereview1(inputs)
	if (locale === "ru") return ru_forms_review_deletereview1(inputs)
	if (locale === "uk") return uk_forms_review_deletereview1(inputs)
	if (locale === "ar") return ar_forms_review_deletereview1(inputs)
	if (locale === "hi") return hi_forms_review_deletereview1(inputs)
	if (locale === "th") return th_forms_review_deletereview1(inputs)
	if (locale === "ja") return ja_forms_review_deletereview1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_deletereview1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_deletereview1(inputs)
	return ko_forms_review_deletereview1(inputs)
});
export { forms_review_deletereview1 as "forms.review.deleteReview" }